module.exports = __webpack_public_path__ + "static/media/icon_starred_seet_blue.5fb8648f.svg";